import { Injectable } from '@angular/core';
import {
    DueInvoiceIdealDetailInterface,
    InvoiceAdvanceInterface,
    Message,
    TotaalFacturenFactuurInterface,
    VaststellingFactuurVerrekeningInterface,
} from '@app/core/interfaces';
import * as fromInvoices from '@app/store/my-zone/invoices/invoices.selectors';
import * as fromMyZone from '@app/store/my-zone/my-zone';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';

/** @deprecated moved to libs folder */
@Injectable({ providedIn: 'root' })
export class InvoicesSelectorService {
    public getInvoiceLoading$: Observable<boolean> = this.store.pipe(select(fromInvoices.getInvoiceLoading));
    public getInvoicesLoaded$: Observable<string[]> = this.store.pipe(select(fromInvoices.getInvoicesLoaded));
    public getInvoicesYearsLoaded$: Observable<number[]> = this.store.pipe(select(fromInvoices.getInvoicesYearsLoaded));
    public getInvoiceFormLoading$: Observable<boolean> = this.store.pipe(select(fromInvoices.getInvoiceFormLoading));
    public getInvoiceErrors$: Observable<Message[]> = this.store.pipe(select(fromInvoices.getInvoiceErrors));
    public getInvoicesPaymentsByYear$: Observable<DueInvoiceIdealDetailInterface[]> = this.store.pipe(
        select(fromInvoices.getInvoicesPaymentsByYear)
    );
    public getSelectedInvoice$: Observable<TotaalFacturenFactuurInterface> = this.store.pipe(
        select(fromInvoices.getSelectedInvoice)
    );
    public getSelectedInvoicePayment$: Observable<DueInvoiceIdealDetailInterface> = this.store.pipe(
        select(fromInvoices.getSelectedInvoicePayment)
    );
    public getSelectedInvoiceCalculation$: Observable<VaststellingFactuurVerrekeningInterface> = this.store.pipe(
        select(fromInvoices.getSelectedInvoiceCalculation)
    );
    public getSelectedInvoiceAdvance$: Observable<InvoiceAdvanceInterface> = this.store.pipe(
        select(fromInvoices.getSelectedInvoiceAdvance)
    );
    public getSelectedInvoicesByYear$: Observable<TotaalFacturenFactuurInterface[]> = this.store.pipe(
        select(fromInvoices.getSelectedInvoicesByYear)
    );
    public getInvoiceSelectedYear$: Observable<number> = this.store.pipe(select(fromInvoices.getInvoiceSelectedYear));
    public getInvoiceYears$: Observable<number[]> = this.store.pipe(select(fromInvoices.getInvoiceYears));
    public getToPayIdeal$: Observable<number> = this.store.pipe(select(fromInvoices.getToPayIdeal));
    public getToPayOnline$: Observable<number> = this.store.pipe(select(fromInvoices.getToPayOnline));

    constructor(private store: Store<fromMyZone.State>) { }
}
